import React, {useEffect} from 'react';
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { closeDrawer } from "../../actions/drawerActions";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import IntegrationLogDetailsHook from "../qd/integrations/IntegrationLogDetailsHook";
import ArgoAppBarHook from "../common/ArgoAppBarHook";


function IntegrationLogDetailsDrawerHook(props) {
    const dispatch = useDispatch();

    const handleCloseDrawer = () => {
        dispatch(closeDrawer()); // TODO For some reason this drawer requires 2 closes to work?
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                e.preventDefault()
                handleCloseDrawer()
            }
        }

        document.addEventListener("keydown", handleKeyDown, true)

        return () => {document.removeEventListener("keydown", handleKeyDown, true)}
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ClickAwayListener onClickAway={handleCloseDrawer}>
            <div>
                <ArgoAppBarHook
                    title="Integration Log Details"
                    showMenuArrowButton="LEFT"
                    onLeftIconButtonTouchTap={handleCloseDrawer}
                    isDrawer={true}
                    width={integrationLogDetailsDrawerProps.width}
                />

                <div style={{ height: '64px' }}></div>

                <div>
                    <IntegrationLogDetailsHook id={props.id} />
                </div>
            </div>
        </ClickAwayListener>
    );
}

IntegrationLogDetailsDrawerHook.propTypes = {
    id: PropTypes.number
};

const integrationLogDetailsDrawerProps = {
    opensecondary: true,
    width: "70%",
    docked: false,
    anchor: "right",
    setLoadingState: PropTypes.func,
};

export default IntegrationLogDetailsDrawerHook;
export { integrationLogDetailsDrawerProps };